export const filterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="ICON"
            height={32}
            width={32}
            viewBox="0 0 32 32"
            fill="var(--dark-brown-color)"
        >
            <path d="m3 6h14.142c.447 1.72 2 3 3.858 3s3.411-1.28 3.858-3h4.142c.552 0 1-.448 1-1s-.448-1-1-1h-4.142c-.447-1.72-2-3-3.858-3s-3.411 1.28-3.858 3h-14.142c-.552 0-1 .448-1 1s.448 1 1 1zm18-3c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm8 23h-4.142c-.447-1.72-2-3-3.858-3s-3.411 1.28-3.858 3h-14.142c-.552 0-1 .448-1 1s.448 1 1 1h14.142c.447 1.72 2 3 3.858 3s3.411-1.28 3.858-3h4.142c.552 0 1-.448 1-1s-.448-1-1-1zm-8 3c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm8-14h-15.142c-.447-1.72-2-3-3.858-3s-3.411 1.28-3.858 3h-3.142c-.552 0-1 .448-1 1s.448 1 1 1h3.142c.447 1.72 2 3 3.858 3s3.411-1.28 3.858-3h15.142c.552 0 1-.448 1-1s-.448-1-1-1zm-19 3c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" />
        </svg>
    );
};